import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import AuthProvider from '../../providers/auth.provider';
import CheckCMSNewVersionLayer from '../../components/layout/CheckCMSNewVersionLayer';
import { config } from '../../config';

const liffId = config.liff_id.paymentBenefit;

const PaymentBenefit = loadable(() => import('./PaymentBenefit'), { fallback: null });

const PaymentBenefitForm = loadable(() => import('./PaymentBenefitForm'), { fallback: null });

const PaymentBenefitSummary = loadable(() => import('./PaymentBenefitSummary'), { fallback: null });

const PaymentBenefitOtp = loadable(() => import('./PaymentBenefitOtp'), { fallback: null });

const PaymentBenefitComplete = loadable(() => import('./PaymentBenefitComplete'), { fallback: null });

const NotFound = loadable(() => import('../NotFound'), { fallback: null });

export default function PaymentBenefitRoute() {
    return (
        <Routes>
            <Route path="/" element={
                <AuthProvider liffId={liffId}>
                    <CheckCMSNewVersionLayer>
                        <PaymentBenefit />
                    </CheckCMSNewVersionLayer>
                </AuthProvider>
            } />
            <Route path="form" element={<PaymentBenefitForm />} />
            <Route path="summary" element={<PaymentBenefitSummary />} />
            <Route path="otp" element={<PaymentBenefitOtp />} />
            <Route path="complete" element={<PaymentBenefitComplete />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}
